import ConversationType from 'owa-service/lib/contract/ConversationType';
import isItemView from 'mini-mail-list-store/lib/utils/isItemView';
import Item from 'owa-service/lib/contract/Item';
import { MailListRowDataType } from 'mini-mail-list-store/lib/store/schema/MailListRowDataType';

export function getConversationOrItemIdFromRow(row: MailListRowDataType) {
    if (isItemView()) {
        return (row as Item)?.ItemId?.Id ?? '-1';
        // "-1": this Id will fail the subsequent gets
    }
    return (row as ConversationType)?.ConversationId?.Id ?? '-1';
}
